import Vue from 'vue';
import Router from 'vue-router';
import applyRouterMiddlewares from './applyMiddlewares';

import { routes } from './routes';

Vue.use(Router);

// const router =  new Router({
//     routes,
//     scrollBehavior() {
//         return { x: 0, y: 0 };
//     }
// });

const createRouter = () => new Router({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset路由
}

applyRouterMiddlewares(router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js